import education from '../data/EducationData.json'
import "../styles/Education.css"
import React from 'react'

function Education() {
    return (
        <div className='section' id="education-section">
            <h1 className="section-title" id="education"> ~/education </h1>
                <div className="section-content" id="education-content"></div>
            <div className='section-content'>
                <div >
                {education.map((edu) => (
                    <div id="schools">
                        <h2>{edu.institution}</h2>
                        <span >
                            {edu.degrees.map((item : string) => (
                                <li className="degree">{item}</li>
                            ))}
                        </span> <span className="grad-date"> {edu.graduation}</span>
                        <div className="details">
                            {edu.details.map((item : string) => (
                                <li>{item}</li>
                            ))}
                        </div>
                    </div>
                ))}
                </div>
            </div>
        </div>
    )
}
export default Education;